import * as yup from "yup";

export const transaction_schema = {
  from_date: "",
  to_date: "",
};

export const transaction_validation_schema = yup.object().shape({
  from_date: yup.date().required("from_date_required"),
  to_date: yup.date().required("to_date_required"),
});
